import { defineComponent as o, createElementBlock as t, openBlock as l, renderSlot as r } from "vue";
const n = { class: "flex w-full grow items-center gap-8 overflow-hidden p-12" }, c = /* @__PURE__ */ o({
  __name: "DocumentLabelWrapper",
  props: {
    isSmall: { type: Boolean, default: !1 }
  },
  setup(a) {
    return (e, s) => (l(), t("div", n, [
      r(e.$slots, "default")
    ]));
  }
});
export {
  c as default
};
